/* global process:true */

/**
 * Makes API url based on config from state
 *
 * @param  {Object} state - application state
 * @param  {String} path - API path
 * @return {String} - compiled API url
 */
export default function toAPIUrl(state, path) {
  if (process.env.IS_BROWSER) {
    var url = state.apiUrls.webapi.match(/^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)(\/[^?#]*)(\?[^#]*|)(#.*|)$/);
    return "".concat(url[5]).concat(path);
  }

  return "".concat(state.apiUrls.webapi).concat(path);
}